import { render, staticRenderFns } from "./ServerSpecs.vue?vue&type=template&id=4b6152fe&"
import script from "./ServerSpecs.vue?vue&type=script&lang=js&"
export * from "./ServerSpecs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports